export default "__VITE_ASSET__DqR3uVWm__"